import React from 'react';

import { createClassName } from 'utils/createClassName';

import './iconRowStyles.css';

type Props = {
  icon: React.ReactNode;
  text: React.ReactNode;
};

export const IconRowComponent: React.FC<Props> = (props) => {
  const { icon, text } = props;

  const createHomePageLayoutClassName = createClassName('iconRow');

  const wrapperClassName = createHomePageLayoutClassName('wrapper');

  const iconSlotClassName = createHomePageLayoutClassName('iconSlot');

  const textSlotClassName = createHomePageLayoutClassName('textSlot');

  return (
    <div className={wrapperClassName}>
      <div className={iconSlotClassName}>{icon}</div>
      <div className={textSlotClassName}>{text}</div>
    </div>
  );
};
